import { ProductDto } from '@app/types/product.type';

/**
 * Вычислить экономию для yearly плана по сравнению с monthly
 * Возвращает экономию в долларах или undefined если нет экономии
 */
export function calculateSavings(
  yearlyProduct: ProductDto,
  monthlyProduct: ProductDto | undefined,
): number | undefined {
  if (!monthlyProduct) {
    return undefined;
  }

  const yearlyPrice = parseFloat(yearlyProduct.price.amount);
  const monthlyPrice = parseFloat(monthlyProduct.price.amount);
  const yearlyEquivalent = monthlyPrice * 12;

  const savings = yearlyEquivalent - yearlyPrice;

  // Возвращаем экономию только если она положительная
  return savings > 0 ? savings : undefined;
}
